<!--
 * @Descripttion: 合同管理
 * @version:
 * @Author: loong
 * @Date: 2022-09-09 14:53:01
 * @LastEditors: loong
 * @LastEditTime: 2022-10-10 13:01:15
-->
<template>
  <div class="contractBody">
    <div class="contractTitle">合同管理</div>
    <div class="content_table">
      <tableTotal @handleClick="handleClick" :index-show="configTable.indexShow" :config-data="configTable.configData" :table-data="configTable.tableData" :loading="configTable.loading"></tableTotal>
      <div class="pagination_box m-t-20">
        <el-pagination @current-change="getData" @size-change="handleSizeChange" :current-page.sync="configTable.current" layout="total, sizes, prev, pager, next, jumper" background :page-sizes="[10,15,20]" :page-size="configTable.pageSize" :total="configTable.total"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import tableTotal from "@/components/TableTotal/TableTotal";
  export default {
    name: "managementContract",
    components: {
      tableTotal
    },
    props: {

    },
    directives: {},
    filters: {},
    extends: {},
    mixins: {},
    data() {
      return {
        pdfUrl: '',
        // 配置表格
        configTable: {
          loading: false,
          indexShow: false,
          configData: [{
              value: 'name',
              label: '企业名称',
              // type: 'img',
              align: 'left'
            }, {
              value: 'applyNumber',
              label: '申请编号',
              align: 'left'
            }, {
              value: 'applyTime',
              label: '申请时间',
              align: 'left'
            }, {
              value: 'status',
              label: '状态',
              align: 'left',
              objList: {
                0: '待审核',
                1: '审核通过',
                2: '审核不通过',
              }
            },
            {
              label: '操作',
              width: '220',
              fixed: 'right',
              type: 'handleList',
              buttonList: [
                { label: '查看', event: 'seeData', show: true, showText: true },
                // { label: '下载', event: 'evaluation', show: true, showText: true },
              ]
            }
          ],
          tableData: [],
          current: 1, // 当前页码
          total: 1, // 数据总条数
          pageSize: 10
        }
      };
    },
    computed: {},
    watch: {},
    beforeCreate() {
      // 生命周期钩子：组件实例刚被创建，组件属性计算之前，如 data 属性等
    },
    created() {
      // 生命周期钩子：组件实例创建完成，属性已绑定，但 DOM 还未生成，el 属性还不存在
      this.info();
    },
    beforeMount() {
      // 生命周期钩子：模板编译/挂载之前
    },
    mounted() {
      // 生命周期钩子：模板编译、挂载之后（此时不保证已在 document 中）
    },
    beforeUpate() {
      // 生命周期钩子：组件更新之前
    },
    updated() {
      // 生命周期钩子：组件更新之后
    },
    activated() {
      // 生命周期钩子：keep-alive 组件激活时调用
    },
    deactivated() {
      // 生命周期钩子：keep-alive 组件停用时调用
    },
    beforeDestroy() {
      // 生命周期钩子：实例销毁前调用
    },
    destroyed() {
      // 生命周期钩子：实例销毁后调用
    },
    errorCaptured(err, vm, info) {
      // 生命周期钩子：当捕获一个来自子孙组件的错误时被调用。此钩子会收到三个参数：错误对象、发生错误的组件实例以及一个包含错误来源信息的字符串。
    },
    methods: {
      info() {
        // 获取数据
        this.getData();
      },
      getData() {
        this.configTable.loading = true;
        this.$http.get(this.$const.SellerCenter.supplierOne, "", true).then((res) => {
          if (res.data) {

            this.configTable.tableData = [res.data.supplierInfo];
            this.pdfUrl = res.data.supplierContract.contractUrl;
            this.configTable.loading = false;
            // console.log(res.data, this.configTable.tableData);
          }

        }).catch((error) => {
          // console.log(error, 'error')
        });

      },
      handleClick(event, data, text) {
        switch (event) {
          case 'seeData':
            // console.log(event, data, text);
            window.open(this.pdfUrl);
            break
          case 'evaluation':
            // console.log(event, data, text);

            break
        }
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getData();
      },
      changeStatus(data, index) {
        this.active = index;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .contractTitle {
    font-weight: 600;
    font-style: normal;
    font-size: 17px;
    color: #333;
    text-align: left;
    line-height: 40px;
    padding-bottom: 10px;
  }
</style>
